import { z } from 'zod';

import { GetTextIdTranslationType } from '@/components/shared/hooks/useTranslation';
import { requiredString } from '@/utils/zodUtils';

export const SetLenderRequestIdSchema = (t: GetTextIdTranslationType) =>
  z
    .object({
      lenderRequestId: requiredString(t),
    })
    .strict();

export type SetLenderRequestIdType = z.infer<ReturnType<typeof SetLenderRequestIdSchema>>;
